<div class="ipm-funnel-chat-section">
   <div class="chat-heading">
        <h4 class="ipm-heading">{{ title }}</h4>
        <p class="m-0">{{ subtitle }}</p>
    </div>
  <div class="ipm-funnel-chat-section-row" *ngFor="let s of stages" [class.weak]="s.weak">
    <div class="label">{{ s.label }}</div>
    <div class="track">
      <div class="shape" [style.width.%]="s.width">
        <span class="count">{{ s.countText }}</span>
      </div>
      <span class="rate">({{ s.rateText }})</span>
    </div>
    <div class="weak-badge" *ngIf="s.weak">Weak</div>
  </div>

  <div class="insight" *ngIf="insight">
    <div class="ic"><i class="pi pi-info-circle"></i></div>
    <div>
      <h3>FUNNEL INSIGHT</h3>
      <p>{{ insight }}</p>
    </div>
  </div>
</div>